export default __webpack_public_path__ + "static/get-quote-bg-84fcb3cfb52b10d2706046e3b11a1071.png";